module.exports = __webpack_public_path__ + "static/img/exhibitor_diamond_cn.8aa3b2d9.png";